"use client";
import "./styles/StatusDialog.css";
import { CheckCircle, XCircle } from "react-icons/hi2";

const StatusDialog = ({
    isOpen,
    onClose,
    type = "success", // "success" or "error"
    title = type === "success" ? "Congratulations!" : "Error",
    message = type === "success"
        ? "You've successfully joined the MAPex Card waiting list! You will be notified via email to set up your delivery address and receive your card."
        : "Something went wrong. Please try again later.",
    buttonText = type === "success" ? "Continue Exploring" : "Learn More",
    onButtonClick,
    className = "",
}) => {
    if (!isOpen) return null;

    const handleButtonClick = () => {
        if (onButtonClick) {
            onButtonClick();
        } else {
            onClose();
        }
    };

    return (
        <div className="status-dialog-overlay">
            <div className={`status-dialog ${type} ${className}`}>
                <div className="status-icon">
                    {type === "success" ? (
                        <svg
                            width="95"
                            height="95"
                            viewBox="0 0 95 95"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <circle
                                cx="47.5"
                                cy="47.5"
                                r="47.5"
                                fill="url(#paint0_linear_1117_6495)"
                            />
                            <path
                                d="M64.6527 35.625L41.5212 58.7153L31.0068 48.2197"
                                stroke="white"
                                stroke-width="6"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                            <defs>
                                <linearGradient
                                    id="paint0_linear_1117_6495"
                                    x1="7.15942"
                                    y1="-20.3275"
                                    x2="87.8406"
                                    y2="115.328"
                                    gradientUnits="userSpaceOnUse"
                                >
                                    <stop stop-color="#AF8FF9" />
                                    <stop
                                        offset="0.972972"
                                        stop-color="#0905FF"
                                    />
                                </linearGradient>
                            </defs>
                        </svg>
                    ) : (
                        <div>
                            <svg
                                width="95"
                                height="95"
                                viewBox="0 0 95 95"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <circle
                                    cx="47.5"
                                    cy="47.5"
                                    r="47.5"
                                    fill="url(#paint0_linear_1117_6494)"
                                />
                                <path
                                    d="M60.1443 33.9217L33.8557 60.2103M33.8557 33.9217L60.1443 60.2103"
                                    stroke="white"
                                    stroke-width="4"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                                <defs>
                                    <linearGradient
                                        id="paint0_linear_1117_6494"
                                        x1="5.36956"
                                        y1="6.22271"
                                        x2="114.395"
                                        y2="69.7706"
                                        gradientUnits="userSpaceOnUse"
                                    >
                                        <stop stop-color="#D52C42" />
                                        <stop
                                            offset="0.972972"
                                            stop-color="#0905FF"
                                        />
                                    </linearGradient>
                                </defs>
                            </svg>
                        </div>
                    )}
                </div>

                <h2 className="status-title">"{title}"</h2>

                <p className="status-message">"{message}"</p>

                <button
                    className={`status-button success-button`}
                    onClick={handleButtonClick}
                >
                    {buttonText}
                </button>
            </div>
        </div>
    );
};

export default StatusDialog;
